import DashboardPage from './DashboardPage.container';

export default DashboardPage;
